import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Table, Badge, Alert } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaSearch, FaLaptop, FaCheck, FaTimes } from 'react-icons/fa';
import { Modal } from 'antd';
import { useComedorLectoresOffline } from '../../../services/hooks/useComedorLectoresOffline';
import { useComedores } from '../../../services/hooks/useComedores';
import { useLectores } from '../../../services/hooks/useLectores';
import { useTipoServiciosAlimentacion } from '../../../services/hooks/useTipoServiciosAlimentacion';
import ModalComedorLectorOffline from '../../../components/modals/ModalComedorLectorOffline';

const MantenimientoComedorLectoresOffline = () => {
  const navigate = useNavigate();

  const {
    estaciones,
    loading,
    fetchByProyecto,
    createEstacion,
    updateEstacion,
    deactivateEstacion,
    regenerarToken,
  } = useComedorLectoresOffline();

  const { comedores, fetchComedoresByProyecto } = useComedores();
  const { lectores, fetchLectoresByProyecto, fetchLectoresByComedor } = useLectores();
  const {
    tipoServiciosAlimentacion,
    fetchTipoServiciosAlimentacion,
  } = useTipoServiciosAlimentacion();

  const [filtro, setFiltro] = useState('');
  const [seleccionado, setSeleccionado] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  const [estacionEdit, setEstacionEdit] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
    if (selectedProject?.id) {
      fetchByProyecto(selectedProject.id);
    }
  }, [fetchByProyecto]);

  const loadModalDependencies = async (idComedor = null) => {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
    if (!selectedProject?.id) return;
    await Promise.all([
      fetchComedoresByProyecto(selectedProject.id),
      fetchLectoresByProyecto(selectedProject.id),
      fetchTipoServiciosAlimentacion(),
    ]);
    if (idComedor) {
      await fetchLectoresByComedor(idComedor);
    }
  };

  const handleSelect = (item) => {
    setSeleccionado((prev) => (prev?.id === item.id ? null : item));
  };

  const handleOpenCreate = async () => {
    await loadModalDependencies();
    setModalMode('create');
    setEstacionEdit(null);
    setShowModal(true);
  };

  const handleOpenEdit = async () => {
    if (!seleccionado) {
      toast.error('Seleccione una estación para editar', { autoClose: 2000 });
      return;
    }
    await loadModalDependencies(seleccionado.id_comedor);
    setModalMode('edit');
    setEstacionEdit(seleccionado);
    setShowModal(true);
  };

  const handleSave = async (payload) => {
    try {
      if (modalMode === 'create') {
        const created = await createEstacion(payload);
        if (created?.id) {
          setModalMode('edit');
          setEstacionEdit(created);
          setSeleccionado(created);
          toast.info('Copie el token de estación e ingréselo en Electron.', { autoClose: 5000 });
          return;
        }
        setShowModal(false);
        setSeleccionado(null);
      } else {
        await updateEstacion(estacionEdit.id, payload);
        setShowModal(false);
        setSeleccionado(null);
      }
    } catch (_err) {
      // toast en hook
    }
  };

  const handleRegenerarToken = async (id) => {
    const updated = await regenerarToken(id);
    if (updated?.token_acceso) {
      setEstacionEdit((prev) => (prev ? { ...prev, ...updated } : prev));
      setSeleccionado((prev) => (prev?.id === id ? { ...prev, ...updated } : prev));
    }
    return updated;
  };

  const confirmDeactivate = async () => {
    if (!seleccionado) return;
    setShowDeleteModal(false);
    try {
      await deactivateEstacion(seleccionado.id);
      setSeleccionado(null);
    } catch (_err) {
      // toast en hook
    }
  };

  const filtradas = estaciones.filter((e) => {
    const q = filtro.toLowerCase();
    return (
      String(e.codigo || '').toLowerCase().includes(q) ||
      String(e.nombre || '').toLowerCase().includes(q) ||
      String(e.comedor_nombre || '').toLowerCase().includes(q) ||
      String(e.lector_nombre || '').toLowerCase().includes(q)
    );
  });

  return (
    <>
      <style>
        {`
          .dh-maintenance-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          .dh-main-title { font-size: 2.2rem; font-weight: 700; margin: 0; }
          .dh-main-subtitle { font-size: 1.1rem; opacity: 0.9; margin: 0.5rem 0 0 0; }
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          .dh-card-header {
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-weight: 700;
          }
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none; color: white; border-radius: 12px; padding: 12px 20px; font-weight: 600;
          }
          .btn-dh-warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
            border: none; color: white; border-radius: 12px; padding: 12px 20px; font-weight: 600;
          }
          .btn-dh-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border: none; color: white; border-radius: 12px; padding: 12px 20px; font-weight: 600;
          }
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none; color: white; border-radius: 12px; padding: 12px 20px; font-weight: 600;
          }
          .dh-form-control {
            border: 2px solid #e5e7eb; border-radius: 10px; padding: 12px 16px;
          }
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
          }
          .dh-enhanced-table {
            border-collapse: separate; border-spacing: 0; border-radius: 15px; overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05); background: white;
          }
          .dh-enhanced-table thead th {
            background: #374151 !important; color: white !important; font-weight: 700 !important;
            font-size: 0.875rem !important; text-transform: uppercase !important;
            padding: 1rem 0.75rem !important; border: none !important;
            position: sticky !important; top: 0 !important; z-index: 10 !important;
          }
          .dh-enhanced-table tbody td {
            padding: 0.75rem; border: none; border-bottom: 1px solid #f3f4f6;
            font-size: 0.9rem; vertical-align: middle;
          }
          .dh-enhanced-table tbody tr:hover {
            background: linear-gradient(135deg, #f9fafb 0%, rgba(102, 126, 234, 0.02) 100%) !important;
          }
          .dh-enhanced-table tbody tr.selected {
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%) !important;
            border-left: 4px solid #667eea;
          }
          .dh-badge-success {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: white; border-radius: 10px; padding: 6px 12px; font-weight: 600; font-size: 0.85rem;
          }
          .dh-badge-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white; border-radius: 10px; padding: 6px 12px; font-weight: 600; font-size: 0.85rem;
          }
          .dh-badge-info {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white; border-radius: 10px; padding: 4px 8px; font-weight: 600; font-size: 0.75rem;
            margin-right: 4px; display: inline-block;
          }
        `}
      </style>

      <div className="dh-maintenance-bg">
        <ToastContainer />
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="dh-main-title">
                  <FaLaptop className="me-3" />
                  Comedores Lectores Offline
                </h1>
                <p className="dh-main-subtitle">
                  Configuración de estaciones Electron: código, comedor, lector y servicios habilitados
                </p>
              </div>
              <Button className="btn-dh-secondary d-flex align-items-center" onClick={() => navigate('/home')}>
                <FaArrowLeft className="me-2" />
                Volver
              </Button>
            </div>
          </Container>
        </div>

        <Container fluid className="py-4">
          <Row>
            <Col lg={12}>
              <Card className="dh-card">
                <Card.Header className="dh-card-header">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h5 className="mb-0">Estaciones offline</h5>
                    <div className="d-flex gap-2 flex-wrap">
                      <Button className="btn-dh-primary d-flex align-items-center" onClick={handleOpenCreate}>
                        <FaPlus className="me-2" />
                        Nueva
                      </Button>
                      <Button className="btn-dh-warning d-flex align-items-center" onClick={handleOpenEdit}>
                        <FaEdit className="me-2" />
                        Editar
                      </Button>
                      <Button
                        className="btn-dh-danger d-flex align-items-center"
                        disabled={!seleccionado}
                        onClick={() => setShowDeleteModal(true)}
                      >
                        <FaTrash className="me-2" />
                        Desactivar
                      </Button>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: '2rem' }}>
                  <div className="mb-4 position-relative">
                    <Form.Control
                      type="search"
                      className="dh-form-control"
                      placeholder="Buscar por código, nombre, comedor o lector..."
                      value={filtro}
                      onChange={(e) => setFiltro(e.target.value)}
                      style={{ paddingLeft: '3rem' }}
                    />
                    <FaSearch
                      className="position-absolute"
                      style={{ left: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}
                    />
                  </div>

                  <div className="table-responsive" style={{ maxHeight: 600, overflowY: 'auto' }}>
                    <Table className="dh-enhanced-table">
                      <thead>
                        <tr>
                          <th style={{ width: 50 }}></th>
                          <th>Código</th>
                          <th>Nombre</th>
                          <th>Comedor</th>
                          <th>Lector</th>
                          <th>Servicios</th>
                          <th className="text-center">Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={7} className="text-center py-5">
                              <div className="spinner-border text-primary" role="status" />
                            </td>
                          </tr>
                        ) : filtradas.length === 0 ? (
                          <tr>
                            <td colSpan={7} className="text-center py-5">
                              <Alert variant="info" className="mb-0">
                                No hay estaciones offline configuradas
                              </Alert>
                            </td>
                          </tr>
                        ) : (
                          filtradas.map((item) => (
                            <tr
                              key={item.id}
                              className={seleccionado?.id === item.id ? 'selected' : ''}
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleSelect(item)}
                            >
                              <td onClick={(e) => e.stopPropagation()}>
                                <Form.Check
                                  type="checkbox"
                                  checked={seleccionado?.id === item.id}
                                  onChange={() => handleSelect(item)}
                                />
                              </td>
                              <td style={{ fontWeight: 700 }}>{item.codigo}</td>
                              <td>{item.nombre}</td>
                              <td>{item.comedor_nombre || `#${item.id_comedor}`}</td>
                              <td>{item.lector_nombre || `#${item.id_lector}`}</td>
                              <td>
                                {(item.servicios || []).length === 0 ? (
                                  <span className="text-muted">Sin servicios</span>
                                ) : (
                                  (item.servicios || []).map((s) => (
                                    <span key={`${item.id}-${s.codigo}`} className="dh-badge-info">
                                      {s.codigo}
                                    </span>
                                  ))
                                )}
                              </td>
                              <td className="text-center">
                                {item.activo ? (
                                  <Badge className="dh-badge-success">
                                    <FaCheck /> Activo
                                  </Badge>
                                ) : (
                                  <Badge className="dh-badge-danger">
                                    <FaTimes /> Inactivo
                                  </Badge>
                                )}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ModalComedorLectorOffline
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={handleSave}
        estacion={estacionEdit}
        comedores={comedores}
        lectores={lectores}
        tiposServicio={tipoServiciosAlimentacion}
        onComedorChange={fetchLectoresByComedor}
        onRegenerarToken={handleRegenerarToken}
      />

      <Modal
        title="Desactivar estación"
        open={showDeleteModal}
        onOk={confirmDeactivate}
        onCancel={() => setShowDeleteModal(false)}
        okText="Desactivar"
        cancelText="Cancelar"
        okType="danger"
      >
        <p>
          ¿Desactivar la estación <strong>{seleccionado?.codigo}</strong>? Electron no podrá
          activarla mientras esté inactiva.
        </p>
      </Modal>
    </>
  );
};

export default MantenimientoComedorLectoresOffline;
